/**
 * 輸入對局讀秒時間，取得計算剩下多少秒數的 function
 * @param {Number} gameByoYomiTime 對局讀秒時間
 * @return {Function} (time, byoYomiAmount, byoYomiTime) => sec
 */
export function getCountTotalSecFunc(gameByoYomiTime) {
  /**
   * 計算總共剩下多少秒數
   * @param {Number} time 對局讀秒時間
   * @param {Number} byoYomiTime 對局讀秒時間
   * @param {Number} byoYomiAmount 對局讀秒時間
   * @return {Number} sec
   */
  return (time, byoYomiTime, byoYomiAmount) =>
    time + (byoYomiAmount - 1) * gameByoYomiTime + byoYomiTime;
}

/**
 * 將秒數還原回剩下多少時間
 * @param {Number} gameByoYomiTime 對局讀秒時間
 * @param {Number} gameByoYomiAmount 對局讀秒次數
 * @return {Function} (sec) => {remainTime, remainByoYomiTime, remainByoYomiAmount}
 */
export function getRevertSecToTimeFunc(gameByoYomiTime, gameByoYomiAmount) {
  /**
   * 將秒數還原回剩下多少時間
   * @param {Number} sec 秒數
   * @return {Object} {remainTime, remainByoYomiTime, remainByoYomiAmount}
   */
  return (sec) => {
    if (sec < 0) {
      return {
        remainTime: 0,
        remainByoYomiTime: 0,
        remainByoYomiAmount: 0,
      };
    }
    const remainByoYomiAmount = Math.min(
      Math.ceil(sec / gameByoYomiTime),
      gameByoYomiAmount
    );
    let remainTime = sec - remainByoYomiAmount * gameByoYomiTime;
    let remainByoYomiTime =
      remainTime > 0 ? gameByoYomiTime : sec % gameByoYomiTime;

    if (remainTime < 0) remainTime = 0;
    if (remainByoYomiTime === 0 && remainByoYomiAmount !== 0)
      remainByoYomiTime = gameByoYomiTime;

    return {remainTime, remainByoYomiAmount, remainByoYomiTime};
  };
}

export default {getCountTotalSecFunc, getRevertSecToTimeFunc};
